import { render, staticRenderFns } from "./AdvancedArrowsBox.vue?vue&type=template&id=e6b84f92&"
import script from "./AdvancedArrowsBox.vue?vue&type=script&lang=js&"
export * from "./AdvancedArrowsBox.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedArrowsBox.vue?vue&type=style&index=0&id=e6b84f92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports